import { Navigate, Route, Routes } from 'react-router-dom';
import Login from '@/routes/Login';
import Landing from '@/routes/Landing';
import Dashboard from '@/routes/Dashboard';
import Apps from '@/routes/Apps';
import Campaigns from '@/routes/Campaigns';
import CampaignDetail from '@/routes/CampaignDetail';
import SettingsKeys from '@/routes/SettingsKeys';
import Profile from '@/routes/Profile';
import Welcome from '@/routes/Welcome';
import { AppShell } from '@/components/AppShell';
import { RequireAuth } from '@/components/RequireAuth';

function Shelled({ children }: { children: React.ReactNode }) {
  return (
    <RequireAuth>
      <AppShell>{children}</AppShell>
    </RequireAuth>
  );
}

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/welcome" element={<Shelled><Welcome /></Shelled>} />
      <Route path="/dashboard" element={<Shelled><Dashboard /></Shelled>} />
      <Route path="/apps" element={<Shelled><Apps /></Shelled>} />
      <Route path="/campaigns" element={<Shelled><Campaigns /></Shelled>} />
      <Route path="/campaigns/:id" element={<Shelled><CampaignDetail /></Shelled>} />
      <Route path="/settings/keys" element={<Shelled><SettingsKeys /></Shelled>} />
      <Route path="/settings/profile" element={<Shelled><Profile /></Shelled>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
